/**
 * poolApi — public, account-less API for waitlist signup and candidate
 * self-service profile management (manage_token-based).
 *
 * These endpoints are PUBLIC (no auth header required), so this module uses its
 * own minimal axios instance rather than the authenticated `services/api.js`
 * instance. We mirror only the baseURL so it points at the same backend.
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const publicApi = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

// POST /api/waitlist — capture an interested email by audience.
export const joinWaitlist = (email, audience) =>
  publicApi.post('/api/waitlist', { email, audience });

// GET /api/manage/:token — load the candidate's own self-view.
export const manageGet = (token) =>
  publicApi.get(`/api/manage/${token}`);

// PATCH /api/manage/:token — update visibility / availability / details.
export const managePatch = (token, data) =>
  publicApi.patch(`/api/manage/${token}`, data);

// DELETE /api/manage/:token — remove the candidate from the pool.
export const manageDelete = (token) =>
  publicApi.delete(`/api/manage/${token}`);

// GET /api/manage/:token/intros — warm-intro requests awaiting the candidate.
export const manageGetIntros = (token) =>
  publicApi.get(`/api/manage/${token}/intros`);

// POST /api/manage/:token/intros/:introId/respond — accept/decline an intro.
export const manageRespondIntro = (token, introId, accept) =>
  publicApi.post(`/api/manage/${token}/intros/${introId}/respond`, { accept });

export default publicApi;
